import { useQuery } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useCountries = () => {
  return useQuery(
    "countries",
    async () => {
      const { data } = await axiosPost("/api/cw/viewCountryFilter");
      return data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useCountries;
